import * as service from "../service";
import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";

/**
 * Student uploads compensation receipt and amount.
 * Backend: POST /api/sponsor/compensation/upload
 */
export const compensationUploadAPI = async (payload: any) => {
  try {
    store.dispatch(controlLoading({ showLoading: true }));
    const resp = await service.call(
      "POST",
      `/api/sponsor/compensation/upload`,
      payload,
    );
    store.dispatch(controlLoading({ showLoading: false }));
    return resp;
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`compensationUploadAPI ${err}`);
    throw err;
  }
};

/**
 * Business approves compensation.
 * Backend: POST /api/sponsor/compensation/approve
 */
export const compensationApproveAPI = async (payload: any) => {
  try {
    store.dispatch(controlLoading({ showLoading: true }));
    const resp = await service.call(
      "POST",
      `/api/sponsor/compensation/approve`,
      payload,
    );
    store.dispatch(controlLoading({ showLoading: false }));
    return resp;
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`compensationApproveAPI ${err}`);
    throw err;
  }
};

/**
 * Business rejects compensation.
 * Backend: POST /api/sponsor/compensation/reject
 */
export const compensationRejectAPI = async (payload: any) => {
  try {
    store.dispatch(controlLoading({ showLoading: true }));
    const resp = await service.call(
      "POST",
      `/api/sponsor/compensation/reject`,
      payload,
    );
    store.dispatch(controlLoading({ showLoading: false }));
    return resp;
  } catch (err) {
    store.dispatch(controlLoading({ showLoading: false }));
    console.error(`compensationRejectAPI ${err}`);
    throw err;
  }
};